import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import storeService from '../../services/storeService';

const LocationSettings = () => {
  const [formData, setFormData] = useState({
    street: '', suburb: '', state: '', postcode: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const { id: storeId } = useParams();

  const australianStates = [
    'ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'
  ];

  const fetchStoreData = useCallback(async () => {
    try {
      const data = await storeService.getStoreById(storeId);
      if (data.address) {
        setFormData(data.address);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [storeId]);

  useEffect(() => {
    fetchStoreData();
  }, [fetchStoreData]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSave = async () => {
    await storeService.updateStore(storeId, { address: formData });
    setSuccess('Location settings saved successfully!');
    setTimeout(() => setSuccess(''), 3000);
  };

  if (isLoading) return <div>Loading location settings...</div>;

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Store Location</h2>
      {success && <p className="bg-green-100 text-green-700 p-3 rounded mb-4">{success}</p>}
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">State*</label>
            <select name="state" value={formData.state} onChange={handleChange} className="mt-1 p-2 border rounded-md w-full">
              <option value="">Select State</option>
              {australianStates.map(state => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select>
          </div>
          <div><label className="block text-sm font-medium text-gray-700">Postcode*</label><input name="postcode" value={formData.postcode} onChange={handleChange} className="mt-1 p-2 border rounded-md w-full" /></div>
          <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700">Suburb*</label><input name="suburb" value={formData.suburb} onChange={handleChange} className="mt-1 p-2 border rounded-md w-full" /></div>
          <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700">Street Address*</label><input name="street" value={formData.street} onChange={handleChange} className="mt-1 p-2 border rounded-md w-full" /></div>
        </div>
        <div className="mt-4 h-64 bg-gray-200 rounded-md flex items-center justify-center text-gray-500">
          Interactive Map Component Placeholder
        </div>
      </div>
      <div className="flex justify-end mt-6">
        <button onClick={handleSave} className="bg-primary text-white px-6 py-2 rounded-md">Save Location</button>
      </div>
    </div>
  );
};

export default LocationSettings;